export default __webpack_public_path__ + "static/media/bb-yv-FTM.b3a96161.png";